const cache = {}
export function responseHandler (response) {
  if (response && response.status === 200) {
    return response.result
  }
  throw new Error(response.message)
}
export function pageResponseHandler (response) {
  if (response && response.status === 200) {
    return { result: response.result, data: response.result.list, totalPage: response.result.page.totalPage, totalCount: response.result.total, pageNo: response.result.page.pageNo, pageSize: response.result.page.pageSize, dictDefine: response.result.dictDefine }
  }
  throw new Error(response.message)
}
export function useCache (promiseCreator, key, retry = true) {
  if (typeof promiseCreator !== 'function') throw Error('promise creator must be a function')
  if (!key || typeof key !== 'string') throw Error('cache key must be a string')
  return new Promise((resolve, reject) => {
    if (!cache[key] || !cache[key].loading || (cache[key].error && retry)) {
      cache[key] = { loading: true, bus: cache[key].bus || [] }
      promiseCreator()
        .then(res => {
          cache[key].data = res
          cache[key].bus.forEach(({ resolve }) => resolve(cache[key].data))
          cache[key].bus = []
        })
        .catch(err => {
          cache[key].error = err
          cache[key].bus.forEach(({ reject }) => reject(cache[key].error))
          cache[key].bus = []
        })
    }
    if (cache[key].data) {
      resolve(cache[key].data)
    } else if (cache[key].error) {
      reject(cache[key].error)
    } else {
      cache[key].bus.push({ resolve, reject })
    }
  })
}
export function clearCache (key) {
  if (!key) {
    Object.keys(cache).forEach(key => {
      cache[key].loading = false
    })
  } else if (cache[key]) {
    cache[key].loading = false
  }
}
